function normalizeRefVersion(baseUid, baseVersion) {
  const version = baseVersion || "latest";
  const isLatest = version === "latest";
  const uid = `${baseUid}${isLatest ? "" : `-${version}`}`;
  const path = isLatest ? "" : `/${version}`;
  const label = isLatest ? "Latest" : version;
  return {
    uid,
    path,
    version,
    isLatest,
    label
  };
}
function normalizeRefVersionList(versions) {
  return [.../* @__PURE__ */ new Set(["latest", ...versions || []])];
}
export {
  normalizeRefVersion,
  normalizeRefVersionList
};
//# sourceMappingURL=references.js.map
